import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

import { uiState } from "./modules/ui.module";
import { appSettingsState } from "./modules/app-settings.module";
import { usersState } from "./modules/users.module";

import { locationsState } from "./modules/locations.module";
import { productsState } from "./modules/products.module";
import { inventoryState } from "./modules/inventory.module";
import { inventoryDetailsState } from "./modules/inventoryDetails.module";

Vue.use(Vuex);

const store: StoreOptions<any> = {
  modules: {
    ui: uiState,
    appSettings: appSettingsState,
    users: usersState,
    products: productsState,
    locations: locationsState,
    inventory: inventoryState,
    inventoryDetails: inventoryDetailsState,
  },
};

export default new Vuex.Store<any>(store);
